import React from 'react';
import Products from '../components/Products';
import BrewingGuide from '../components/BrewingGuide';

const ProductsPage = () => {
  return (
    <div>
      <Products />
      <BrewingGuide />
    </div>
  );
};

export default ProductsPage;

